const Storage = {
  getItem: async (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },
  setItem: async (key: string, value: string | number | boolean) => {
    try {
      return localStorage.setItem(key, value as string);
    } catch (error) {
      return null;
    }
  },
  removeItem: async (key: string) => {
    try {
      return localStorage.removeItem(key);
    } catch (error) {
      return null;
    }
  },
  clear: async () => {
    try {
      return localStorage.clear();
    } catch (error) {
      return null;
    }
  },
};

export default Storage;
